module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_yoso_location_green-863a28f2d0ae13f145e7cde2115a0041.jpg";